export function timecodeToMs(input: string): number | null {
  if (!input || input.trim() === '') return null;

  input = input.trim();

  // Full format: HH:MM:SS,ff
  let match = input.match(/^(\d+):(\d{2}):(\d{2}),(\d{1,2})$/);
  if (match) {
    const [, h, m, s, ff] = match;
    return Number(h) * 3_600_000 + Number(m) * 60_000 + Number(s) * 1_000 + Number(ff.padEnd(2, '0')) * 10;
  }

  // Without fractional: HH:MM:SS
  match = input.match(/^(\d+):(\d{2}):(\d{2})$/);
  if (match) {
    const [, h, m, s] = match;
    return Number(h) * 3_600_000 + Number(m) * 60_000 + Number(s) * 1_000;
  }

  // Minutes and seconds: MM:SS
  match = input.match(/^(\d{1,2}):(\d{2})$/);
  if (match) {
    const [, m, s] = match;
    return Number(m) * 60_000 + Number(s) * 1_000;
  }

  // Seconds
  match = input.match(/^(\d+)$/);
  if (match) return Number(match[1]) * 1_000;

  return null;
}

export function msToTimecode(ms: number): string {
  const h = Math.floor(ms / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  const s = Math.floor((ms % 60_000) / 1_000);
  const ff = Math.floor((ms % 1_000) / 10);
  const pad = (n: number, w = 2) => n.toString().padStart(w, '0');
  return `${pad(h)}:${pad(m)}:${pad(s)},${pad(ff)}`;
}
